

export default function TermsOfServicePage() {
  return (
    <main className="min-h-screen bg-white">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="text-center mb-8">
            <img 
              src="/logo.jpeg" 
              alt="Carz Bazzar Logo" 
              width={120} 
              height={60} 
              className="mx-auto mb-4"
            />
            <h1 className="text-3xl font-bold text-gray-800 mb-2">Terms of Service</h1>
            <p className="text-gray-600">Last updated: {new Date().toLocaleDateString()}</p>
          </div>

          <div className="prose max-w-none">
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              By accessing and using the Carz Bazzar franchise website and services ("Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">2. Use License</h2>
            <p className="text-gray-700 mb-4 leading-relaxed">
              Permission is granted to temporarily access and use the Carz Bazzar franchise services for personal, business evaluation, and franchise-related activities only.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">3. Franchise Applications and Accounts</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              When you create an account or submit a franchise application with us, you must provide information that is accurate, complete, and current at all times.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Contact Us</h2>
            <p className="text-gray-700 mb-4 leading-relaxed">If you have any questions about these Terms of Service, please contact us:</p>
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-gray-700 mb-2"><strong>Email:</strong> carsbazzarmain@gmail.com</p>
              <p className="text-gray-700 mb-2"><strong>Phone:</strong> +91 9773460662</p>
              <p className="text-gray-700"><strong>Address:</strong> Carz Bazzar Franchise, India</p>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}
